import React, { useEffect, useState } from "react";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import { useMemo } from "react";
import colorCategoriesService from "../../../services/color-categories.service";
import LibraryAddOutlinedIcon from "@material-ui/icons/LibraryAddOutlined";
import SelectColorModal from "./SelectColorModal";
import PaletteIcon from "@material-ui/icons/Palette";

const defaultKeys = [
    {
        title: "نام",
        field: "name",
        active: true,
    },
];

export default function ColorsPage() {
    const [data, setData] = useState([]);
    const deleteItem = (item) => {
        return colorCategoriesService.deleteColorCategory(item.id);
    };

    const headerCells = useMemo(
        () => [
            {
                field: "name",
                title: "نام",
                mainField: true,
            },
            {
                field: "colorsName",
                title: "رنگ ها",
                // renderer: (val) =>
                //   val ? <img className="color-circle" src={val} alt="" /> : "-",
            },
        ],
        []
    );

    useEffect(() => {
        onRefresh();
    }, []);

    const onRefresh = async () => {
        const { data, error } = await colorCategoriesService.getColorCategories();
        if (error) {
            return;
        }
        setData(data.map(item => ({
            ...item,
            colorsName: item.colors.map(it => it.name).join(" | ")
        })));
    };
    return (
        <div className="p-3">
            <DataTable
                headCells={headerCells}
                data={data}
                onRefresh={onRefresh}
                rowActions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <PaletteIcon />,
                        modalContent: (props) => <SelectColorModal {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <EditIcon />,
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <DeleteIcon />,
                        modalContent: (props) => (
                            <ConfirmModalContent
                                onConfirm={() => deleteItem(props.data)}
                                confirmText={props.data.name}
                                close={props.close}
                            />
                        ),
                    },
                ]}
                actions={[
                    {
                        modalProps: { maxWidth: "sm" },
                        icon: <AddIcon />,
                        tooltip: "ایجاد دسته بندی",
                        modalContent: (props) => <FormModalContent {...props} />,
                    },
                ]}
                searchKeys={defaultKeys}
                title="دسته بندی رنگ ها"
            />
        </div>
    );
}
